import { IBaseMigrationItemCode } from '../../../interfaces';
import { BaseItemCodeToConditionMappingHandler } from '../../../mappings/base-item-code-to-condition';
import {
  ADAItemSourceEntity,
  ExactADAItem,
  IExactADAItem,
} from '../../source/entities/ada-item';
import { UsedItemCodeConditionSourceEntity } from '../../source/entities/used-item-code-conditions';

export class ExactItemCodeToConditionMappingHandler extends BaseItemCodeToConditionMappingHandler<
  ExactADAItem,
  ADAItemSourceEntity
> {
  sourceEntity = new UsedItemCodeConditionSourceEntity();
  translateFn = (record: IExactADAItem): IBaseMigrationItemCode => ({
    id: record.itemCode,
    itemCode: record.itemCode,
    description: record.description ?? '',
  });
}
